import { useEffect,useState } from "react";
import Cookies from "universal-cookie";
import Left from "./view/left/index";
import Center from "./view/center/index";
import { getVerficaPantalla } from "../../services/public/screen";
import Toasts from "../toast";
import Icon from "../../Icons/general/Icon";
import ScreenConfig from "./configmodal";

function MainView() {
  const [visConfig, setvisConfig] = useState(false);
  const [selectedVoice, setSelectedVoice] = useState(null);
  const [opciones, setOpciones] = useState([]);
  const [showToast, setShowToast] = useState(false);
    
  const [pitch, setPitch] = useState(1.2);
  const [volume, setVolume] = useState(1);
  const [rate, setRate] = useState(0.8);
  const [celdas, setCelda] = useState(8);
  const [celdHeight, setHeight] = useState(8);
     

  let cookies = new Cookies();
  
  //-------
  useEffect(() => 
    {
      setPitch(cookies.get('Ctrpitch')||1.2);
      setVolume(cookies.get('Ctrvolume'|| 1));
      setRate(cookies.get('Ctrrate'||0.8));

      const valor = Number(cookies.get('Ctrceld'));
      if (!isNaN(valor) && valor > 0) {
         setCelda(valor);
       }      

      const valorh = Number(cookies.get('Ctrheig'));
      if (!isNaN(valorh) && valorh > 0) {
         setHeight(valorh);
       }      
 
      return () => 
        {
         
        }
    }, []);
//---- levanta ventana configuracion
const handleConfig = async () => 
      {
         setvisConfig(true);
      };
    
return (
   <> 
     <div className="flex  flex-row  w-full h-full">
        <div className="flex w-[23rem] bg-black ">
            <Left celdas={celdas} celdaheight={celdHeight} voce={selectedVoice}/>
        </div>
        <div className="flex flex-1 bg-border">
            <Center />
        </div>
        <button className="fixed right-2 w-[4rem] h-[4rem] flex text-center items-center justify-center z-50 mt-28 text-white rounded-full shadow-lg  hover:bg-gray-500 transition" onClick={handleConfig}>
            <Icon svg="gear" className="flex w-[3rem] h-[3rem] fill-gray-400 hover:fill-default" title="volumeSlash" />
        </button>
      </div>
     
     
    {showToast ? (
       <Toasts
          type={opciones.type}
          message={opciones.message}
          active={opciones.active}
       ></Toasts>
  ) : (
    ""
  )}

  {visConfig && (
        <ScreenConfig
          show={visConfig}
          handleshow={setvisConfig}
        ></ScreenConfig>
      )}
 </>
  );
}

export default MainView;
